import type { AppMeta, MetaEntity } from '@clientline/contracts';
import { ruleRequiredField } from '@clientline/contracts/rule-required';

/**
 * Позначка обов'язковості з правил сутності (`entity.rules` у `/meta`; field-rules.md, розд. 3.4).
 * Поле, яке тримає правило `error` «поле порожнє» в області `write` (ім'я контакту — правило
 * `named`, contacts.md, розд. 4.1), форма показує й перевіряє як обов'язкове: прапорець `required`
 * сервер йому не ставить, бо прапорець не знає винятку `unless`. Правила лише створення (`on:
 * create`) прапорця не дають: картка інакше не дала б очистити поле в наявного запису. Решту правил
 * рахує сервер, відмова приходить `422 rule_violated`.
 *
 * Додаємо `required` до `flags` один раз — під час завантаження `/meta`, тож форма створення,
 * швидке створення, картка й редактор макета читають ту саму ознаку.
 */
export function withRuleRequired(meta: AppMeta): AppMeta {
  // Відповідь без сутностей (неповні метадані) лишаємо як є: позначка — не привід зламати вхід.
  if (!Array.isArray(meta.entities)) return meta;
  let changed = false;
  const entities = meta.entities.map((entity) => {
    const marked = markRequired(entity);
    if (marked !== entity) changed = true;
    return marked;
  });
  return changed ? { ...meta, entities } : meta;
}

function markRequired(entity: MetaEntity): MetaEntity {
  const keys = new Set<string>();
  for (const rule of entity.rules ?? []) {
    const required = ruleRequiredField(rule);
    if (required?.on === 'write') keys.add(required.field);
  }
  if (!entity.fields.some((f) => keys.has(f.key) && !f.flags.includes('required'))) return entity;
  return {
    ...entity,
    fields: entity.fields.map((f) =>
      keys.has(f.key) && !f.flags.includes('required')
        ? { ...f, flags: [...f.flags, 'required'] }
        : f,
    ),
  };
}
